/* eslint-disable @next/next/no-img-element */
import Marquee from "react-fast-marquee";

interface BankImages {
  imageLink?: string;
  alt?: string;
}

const bankImages: BankImages[] = [
  {
    imageLink: "/alliances-v2/axis.png",
    alt: "Axis Bank",
  },
  {
    imageLink: "/alliances-v2/yes.png",
    alt: "Yes Bank",
  },

  {
    imageLink: "/alliances-v2/icici.png",
    alt: "ICICI Bank",
  },
  {
    imageLink: "/alliances-v2/canara.png",
    alt: "Canara Bank",
  },
  {
    imageLink: "/alliances-v2/csb.png",
    alt: "CSB Bank",
  },
  {
    imageLink: "/alliances-v2/hdfc.png",
    alt: "HDFC Bank",
  },
  {
    imageLink: "/alliances-v2/pnb.png",
    alt: "PNB Bank",
  },
  {
    imageLink: "/alliances-v2/lic.png",
    alt: "LIC Bank",
  },

  {
    imageLink: "/alliances-v2/unity.png",
    alt: "Unity Bank",
  },
];

export default function Alliances(props: any) {
  return (
    <>
      <div className=" lg:flex">
        <div className="w-full mt-4 lg:mt-20 pt-[42px] pb-[90px] lg:py-[50px] ">
          <p className="font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-[35px] lg:leading-[57px] text-brand-textBlack  flex justify-center lg:px-customPadding">
            OUR ALLIANCES
          </p>
          <Marquee
            className="flex justify-around mt-[52px] lg:mt-[68px]"
            autoFill={true}
          >
            <div className="grid grid-cols-5 gap-4">
              {bankImages.map((item, index: number) => (
                <div key={`image-${index}`} className="mx-10">
                  <img
                    src={item.imageLink}
                    className="h-auto w-auto"
                    alt={item.alt}
                  />
                </div>
              ))}
            </div>
          </Marquee>
        </div>
        <div></div>
      </div>
    </>
  );
}
